import React, { Component } from "react";

class Portfolio extends Component {
  render() {
    return (
      <section id="portfolio">
        <div className="row projects">
          <div className="twelve columns collapsed">
            <h1>Check Out Some of My Projects.</h1>
            <div
              id="portfolio-wrapper"
              className="bgrid-quarters s-bgrid-thirds cf"
            >
              <div className="article-wrapper">
                <article className="col-12 col-12-xsmall work-item">
                  <a target="_blank"
                    href="https://ixigo-clone.netlify.app/"
                    className="image fit thumb"
                    rel="noopener noreferrer"
                  >
                    <img src="images\portfolio\ixigo.png" alt="pic-some" />
                  </a>
                  <div className="art-description">
                    <div className="text-wrapper">
                    <h3>Clone of Ixigo.com</h3>

                    <p>
                        A website where user can first register then they can
                        book bus ticket with different types of buses. E.g AC
                        buses,non AC ,volvo etc
                      </p>
                      <p>Tech stack:HTML,CSS,redux,nodejs,mongodb</p>
                      <p>Responsibility : Built a Landing page</p>
                      
                      <p>Team :4 members</p>
                    </div>
                    <ul className="actions">
                      <div className="actions-wrapper">
                      <li>
                          <a target="_blank"
                            href="https://ixigo-clone.netlify.app/"
                            className="button project-button"
                            rel="noopener noreferrer"
                          >
                            View Demo
                          </a>
                        </li>
                        <li>
                          <a target="_blank"
                            href="https://github.com/Sathyaprakashsp666/team-ixigo.com"
                            className="button project-button brands"
                            rel="noopener noreferrer"
                          >
                            <i className="fa fa-github icon"></i>View Source
                          </a>
                        </li>
                      </div>
                    </ul>
                  </div>
                </article>
              </div>

              <div className="article-wrapper">
                <article className="col-12 col-12-xsmall work-item">
                  <a target="_blank"
                    href="https://github.com/kotakrishna/Uboric-clone"
                    className="image fit thumb"
                    rel="noopener noreferrer"
                  >
                    <img src="images\portfolio\uboric.png" alt="pic-some" />
                  </a>
                  <div className="art-description">
                    <div className="text-wrapper">
                      <h3>Clone of Uboric.com </h3>
                      <p>
                        A website where users can find different kinds of
                        utility products from various categories also they can
                        search the product according to their name filter the
                        product according to price and also they can add as many
                        as products cart and place the order.
                      </p>
                      <p>Tech stack:HTML,CSS,JavaScript,Material Ui</p>
                      <p>
                        Responsibility : Built a Header,Footer and Sign in
                        option
                      </p>
                      <p>Team :4 members</p>
                    </div>
                    <ul className="actions">
                      <div className="actions-wrapper">
                        <li>
                          <a target="_blank"
                            href="https://kotakrishna.github.io/Uboric-clone/"
                            className="button project-button"
                            rel="noopener noreferrer"
                          >
                            View Demo
                          </a>
                        </li>
                        <li>
                          <a target="_blank"
                            href="https://github.com/kotakrishna/Uboric-clone"
                            className="button project-button brands"
                            rel="noopener noreferrer"
                          >
                            <i className="fa fa-github icon"></i>View Source
                          </a>
                        </li>
                      </div>
                    </ul>
                  </div>
                </article>
              </div>
              <div className="article-wrapper">
                <article className="col-12 col-12-xsmall work-item">
                  <a target="_blank"
                    href="https://github.com/Raushan8271/cricinfo"
                    className="image fit thumb"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="images\portfolio\cricinfo home.png"
                      alt="react-capstone"
                    />
                  </a>
                  <div className="art-description">
                    <div className="text-wrapper">
                      <h3>Clone of Crickinfo.com </h3>
                      <p>
                        A website where users can see live score of ongoing
                        match as weel as result of completed match also see
                        stats related to team ,player,ground.user can filter
                        news according to their dates as well as searching
                        option
                      </p>
                      <p>Tech stack:HTML,CSS,JavaScript,Advance javascript</p>
                      <p>
                        Responsibility : Built a live score page and news page
                      </p>
                      
                      <p>Team :4 members</p>
                    </div>
                    <ul className="actions">
                      <div className="actions-wrapper">
                      <li>
                          <a target="_blank"
                            href="https://cricinfo.vercel.app/"
                            className="button project-button"
                            rel="noopener noreferrer"
                          >
                            View Demo
                          </a>
                        </li>
                        <li>
                          <a target="_blank"
                            href="https://github.com/Raushan8271/cricinfo"
                            className="button project-button brands"
                            rel="noopener noreferrer"
                          >
                            <i className="fa fa-github icon"></i>View Source
                          </a>
                        </li>
                      </div>
                    </ul>
                  </div>
                </article>
              </div>
              <div className="article-wrapper">
                <article className="col-12 col-12-xsmall work-item">
                  <a target="_blank"
                    href="https://github.com/Amol-Talekar/unbounce"
                    className="image fit thumb"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="images\portfolio\unbounce.png"
                      alt="js-capstone"
                    />
                  </a>
                  <div className="art-description">
                    <div className="text-wrapper">
                      <h3> Clone of Unbounce.com</h3>
                      <p>
                        A website where user can see differnt kind of pages with
                        their design and some varition.
                      </p>
                      <p>Tech stack:HTML,CSS,JavaScript</p>
                      <p>
                        Responsibility : work on Landing page and Login page
                      </p>
                      
                      <p>Team :3 members</p>
                    </div>
                    <ul className="actions">
                      <div className="actions-wrapper">
                      <li>
                          <a target="_blank"
                            href="https://unbounce-mauve.vercel.app/"
                            className="button project-button"
                            rel="noopener noreferrer"
                          >
                            View Demo
                          </a>
                        </li>
                        <li>
                          <a target="_blank"
                            href="https://github.com/Amol-Talekar/unbounce"
                            className="button project-button brands"
                            rel="noopener noreferrer"
                          >
                            <i className="fa fa-github icon"></i>View Source
                          </a>
                        </li>
                      </div>
                    </ul>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Portfolio;
